import BillingConciergeService from 'respona_api/generated/billing-concierge_pb_service';

const service = (function () {
  let instance = null;

  return {
    getInstance: (): BillingConciergeService.BillingConciergeApiServiceClient => {
      if (!instance) {
        // @ts-ignore
        instance = new BillingConciergeService.BillingConciergeApiServiceClient(API_HOST);
      }

      return instance;
    },
  };
})();

export default service;
